import React from 'react';
import { ConfigProvider } from 'antd';

export const StyleProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          // colorPrimary: '#ff0000',
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};
